import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'jsonHighlight', standalone: false })
export class JsonHighlightPipe implements PipeTransform {
  transform(value: unknown): string {
    const json = JSON.stringify(value, null, 2);
    // Escape HTML entities first so raw strings can't inject markup
    const escaped = json
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    return escaped.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(\.\d+)?([eE][+\-]?\d+)?)/g,
      (match) => {
        let cls = 'json-number';
        if (/^"/.test(match)) {
          cls = match.endsWith(':') ? 'json-key' : 'json-string';
        } else if (/true|false/.test(match)) {
          cls = 'json-boolean';
        } else if (/null/.test(match)) {
          cls = 'json-null';
        }
        return `<span class="${cls}">${match}</span>`;
      }
    );
  }
}
